import { render, staticRenderFns } from "./Top-Enum-Group.vue?vue&type=template&id=528febe8"
import script from "./Top-Enum-Group.vue?vue&type=script&lang=js"
export * from "./Top-Enum-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports